(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ledy-scroll-reveal"] && !Shopify.designMode) return;
  try {
    if (!window.__ledyRevealInit) {
    window.__ledyRevealInit = true;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      document.documentElement.classList.add('ledy-reveal-ready');

      const ledyRevealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-ledy-visible');
              ledyRevealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      const observeLedyRevealTargets = () => {
        document.querySelectorAll('[data-ledy-reveal]:not(.is-ledy-visible)').forEach((el) => {
          const delay = el.getAttribute('data-ledy-reveal-delay');
          if (delay) {
            el.style.setProperty('--ledy-reveal-delay', delay + 'ms');
          }
          ledyRevealObserver.observe(el);
        });
      };

      observeLedyRevealTargets();

      // Sections may hydrate after this script runs (theme editor, hot reload).
      document.addEventListener('shopify:section:load', observeLedyRevealTargets);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
